import { PersonShow } from '../persons/show';

export const AuthorShow = () => (
  <PersonShow resource="user_catalog.authors" ns="user_catalog.authors" />
);
